import { Component } from '@angular/core';

@Component({
  selector: 'provider-password-reset',
  templateUrl: './provider-password-reset.component.html'
})
export class ProviderPasswordResetComponent {
  
  action !: string | null;
  headerText : string = 'Forgot your password?';
  icon : string = 'fa-solid fa-key fa-2xl';
  resetting = true;
  translationData:any = {}

  onStepComplete(data:any) {
    //let userType = this.route.parent?.snapshot.data['type'];
    this.translationData = {emailAddr: undefined, 
                            username: data.username, 
                            loginRedirect: data.loginRedirect,
                            hideEmail: 'd-none'} 

    this.resetting = false;  
  }
}
